import React from 'react';
import { func, string } from 'prop-types';
import { UTLabel, UTTouchableWithoutFeedback } from '@widergy/energy-ui';

import Images from 'config/assets';
import { appConfig } from 'config/customization';

import sidebarButtonStyles from '../SidebarButton/styles.module.scss';

import styles from './styles.module.scss';

function SidebarCloseButton({ onClick, children }) {
  return (
    <UTTouchableWithoutFeedback
      className={`${sidebarButtonStyles.container} ${styles.container}`}
      onClick={onClick}
    >
      <img src={Images.sidebarSidemenuClose} className={styles.icon} alt="close" />
      {appConfig.mobileSidebarLogo ? (
        children
      ) : (
        <UTLabel xlarge className={styles.utilityName}>
          {children}
        </UTLabel>
      )}
    </UTTouchableWithoutFeedback>
  );
}

SidebarCloseButton.propTypes = {
  onClick: func.isRequired,
  children: string.isRequired
};

export default SidebarCloseButton;
